module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAoklEQVRYhe2XUQrDMAxD5Z0sN4tyM+dk2se6lrKVtpnXn1pgDMHB4jkfMXB3maTVQWtNG7Wzaq0W5kDSHCR1RFMdIuJLc8jdd3OUiaHmkSaMpEopwyN096F7JCHJDs89WgAEQI/Fk6H3flkmFxSSdGr2EZl8ERh+gL/mDwNJIAkkgSSQBJJAErgtASMp4P0/ulbktBmZ2e429A9JituwUqN6Ah2IrH+E5yfcAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/walleris/images/DIR_CLOSED_32.png
// module id = 52
// module chunks = 0